import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import {useAuth0} from "@auth0/auth0-react";
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';



export const LoginLogoutButton = (props) => {
  const { loginWithRedirect, logout, isAuthenticated, isLoading } = useAuth0();

  if (isLoading){
    return <></>
  }

  return (
    <>
    {!isAuthenticated &&
      <Tooltip title="Login">
        <IconButton
          sx={{":hover": {color: "blue"} }}
          onClick={loginWithRedirect}
        >
          <LoginIcon/>
        </IconButton>
      </Tooltip>
    }
    {isAuthenticated &&
      <Tooltip title="Logout">
        <IconButton
          sx={{":hover": {color: "blue"} }}
          onClick={logout({returnTo: window.location.origin})}
        >
          <LogoutIcon/>
        </IconButton>
      </Tooltip>
    }
    </>
  );

  // return (
  //   <Button variant="contained" onClick={isAuthenticated ? logout : loginWithRedirect}>
  //     {isAuthenticated ? "Logout" : "Login"}
  //   </Button>
  // )
}

export default LoginLogoutButton;